import { Fragment, useState } from "react";
import ModalContainer from "../../Tanda Terima/containers/ModalContainer";
import FormUploadTemplate from "./FormUploadTemplate";
import { CreateButton } from "../../../CommonElements";

const ModalUpdateShift = ({setShift, setMode}) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);

  return (
    <Fragment>
      <CreateButton toggle={toggle}>Import</CreateButton>
      <ModalContainer title="Upload Shift" isOpen={isOpen} toggle={toggle}>
        <FormUploadTemplate toggle={toggle} setShift={setShift} setMode={setMode}/>
      </ModalContainer>
    </Fragment>
  );
};

export default ModalUpdateShift;
